import md5 from 'md5'
import { getCookie, setCookie } from '~/plugins/xl-cookie'
import { CustomerServiceUrl } from '~/constant/reg'

export function isDef(val) {
  return val !== undefined && val !== null
}
export function isNotDef(val) {
  return val === undefined || val === null
}

export function genSign(data = {}) {
  const key = data.sessionid || getCookie('sessionid') || ''
  let name
  let str = ''
  let i = 0
  const arr = []
  // if ('sessionid' in data) {
  //   delete data.sessionid
  // }
  for (name in data) {
    if (Object.prototype.hasOwnProperty.call(data, name)) {
      arr.push(name)
    }
  }
  const len = arr.length
  if (len > 0) {
    arr.sort()
    for (; i < len; i++) {
      if (!['', undefined].includes(data[arr[i]])) {
        str += arr[i] + '=' + data[arr[i]] + '&'
      }
    }
  }
  const sign = md5(str.substring(0, str.length - 1) + '&key=' + key)
  // console.log(str.substring(0, str.length - 1) + '&key=' + key)
  return sign
}

export function getUrlParam(key, url) {
  const query = url || window.location.href
  const regExp = '^.*[\\?|\\&]' + key + '\\=([^\\&|\\/#]*)'
  const reg = new RegExp(regExp)
  const ret = query.match(reg)
  if (ret != null) {
    return decodeURIComponent(ret[1])
  } else {
    return ''
  }
}

export function setXWRefer() {
  const refer = getUrlParam('referfrom')
  if (refer && refer !== 'undefined') {
    setCookie('xwgame_referfrom', refer, { expires: 7 })
  }
  //  else {
  //   removeCookie('xwgame_referfrom')
  // }
}

export function setXWActFrom() {
  const actfrom = getUrlParam('actfrom')
  if (actfrom && actfrom !== 'undefined') {
    setCookie('xwgame_actfrom', actfrom, { expires: 7 })
  }
}

export function getUrlParams(url = window.location.search) {
  const query = url
  const search = query.split('?')[1] || ''
  const cps = search.split('&').reduce((prev, cur) => {
    const [key, value] = cur.split('=')
    return { ...prev, [key]: value }
  }, {})
  return cps
}

export function encodePassword(pw) {
  const arr = md5(pw).split('')
  let prev = arr[2]
  arr[2] = arr[8]
  arr[8] = prev

  prev = arr[17]
  arr[17] = arr[27]
  arr[27] = prev
  return md5(arr.join(''))
}

export function allResolve(promiseLike) {
  return new Promise((resolve) =>
    promiseLike.then((data) => resolve(data)).catch((err) => resolve(err))
  )
}

export async function asyncErrorCaptured(asyncFn) {
  try {
    const data = await asyncFn()
    return [null, data]
  } catch (error) {
    return [error, null]
  }
}

export function tryErrorCaptured(tryFn) {
  try {
    const result = tryFn()
    return [false, result]
  } catch (error) {
    return [true, error]
  }
}

export function checkPlatform() {
  const ua = navigator.userAgent.toLowerCase()
  const UA_IOS_REG = /\b(ipad|iphone|ipod)\b.*? os ([\d_]+)/
  const UA_ANDROID_REG = /\bandroid([^;]+)/
  const UA_WX_REG = /micromessenger/
  const UA_WEIBO_REG = /\bweibo/
  const UA_QZONE_REG = /qzone\//
  const UA_QQ_REG = /qq\//

  const isIOS = UA_IOS_REG.test(ua)
  const isAndroid = UA_ANDROID_REG.test(ua)
  const isWx = UA_WX_REG.test(ua)
  const isWeibo = UA_WEIBO_REG.test(ua)
  const isQzone = UA_QZONE_REG.test(ua)
  const isQQ = UA_QQ_REG.test(ua)
  const isThunder = /ithunder/.test(ua)
  const isGameCenter = /gamecenter/.test(ua)
  return {
    isIOS,
    isAndroid,
    isWx,
    isWeibo,
    isQzone,
    isQQ,
    isThunder,
    isGameCenter,
    isPC: !isIOS && !isAndroid
  }
}

export function curBrowserSuportFlash() {
  let flashObj
  if (process.client) {
    if (typeof window.ActiveXObject !== 'undefined') {
      flashObj = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash')
    } else {
      flashObj = navigator.plugins['Shockwave Flash']
    }
  }
  return !!flashObj
}

export function getThunderVersion() {
  let thunderXVersion = 'pc'
  if (process.client) {
    const userAgent = navigator.userAgent
    // eslint-disable-next-line no-useless-escape
    const match = userAgent.match(/thunder\/([\d\.]*)$/i)
    if (match && match[1]) {
      thunderXVersion = match[1] // 可获取迅雷x的版本号
    }
  }
  return thunderXVersion
}

export function isPcClient() {
  if (process.client) {
    const userAgent = navigator.userAgent
    // eslint-disable-next-line no-useless-escape
    const match = userAgent.match(/thunder\/([\d\.]*)$/i)
    if (match && match[1]) {
      return true
    }
  }
  return false
}

export function isNativeFunExist(callbackName) {
  return new Promise((resolve, reject) => {
    if (process.client && window.native && window.native.CheckNativeFunction) {
      window.native.CheckNativeFunction(`${callbackName}`, (err) => {
        if (err === 0) {
          resolve({
            support: true
          })
        } else {
          resolve({
            support: false
          })
        }
      })
    } else {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('接口出错，请稍后重试')
    }
  })
}

export function openUrl(url) {
  if (process.client) {
    if (getThunderVersion() === 'pc') {
      window.open(url)
    } else {
      isNativeFunExist('OpenURLByDefault').then((result) => {
        if (result.support === true) {
          window.native.CallNativeFunction('OpenURLByDefault', url)
        } else {
          window.native.CallNativeFunction('OpenURLByIEorDefault', url)
        }
      })
    }
  }
}

export function openCustomerService() {
  openUrl(CustomerServiceUrl)
}

export function isChromeAndVersionAbove80() {
  const ua = navigator.userAgent.toLowerCase()
  const chromeMatch = ua.match(/chrome\/([\d.]+)/)
  const chromeVersion = chromeMatch ? chromeMatch[1] : '0'
  const isVersionAbove80 = parseInt(chromeVersion) >= 80
  const isFlash = !!navigator.mimeTypes['application/x-shockwave-flash']
  return isVersionAbove80 && !isFlash
}

export function isGoToLoginLink() {
  const httpsProtocol = 'http:'
  const localProtocol = location.protocol
  const isHttp = localProtocol === httpsProtocol
  const isVersionAbove80 = isChromeAndVersionAbove80()
  return isVersionAbove80 && isHttp
}
